<template>
  <div id="body" class="fadein">
    <!-- style样式引入 -->
    <link rel="stylesheet" href="./static/css/login.css" />
    <!-- 注册窗口 start -->
    <div class="login-box">
      <h2><img src="/static/img/Lighting_s.png" alt="" /></h2>
      <h2>注册</h2>
      <form>
        <div class="user-box">
          <input type="text" v-model="form.mobile" required="" />
          <label>手机</label>
        </div>
        <div class="user-box">
          <input type="password" v-model="form.password" required="" />
          <label>密码</label>
        </div>
        <div class="user-box">
          <input type="password" v-model="cf_password" required="" />
          <label>确认密码</label>
        </div>
        <div class="user-box" style="position:relative">
          <input type="text" v-model="form.code" required="" />
          <label>验证码</label>
          <div class="getcode">
            <a href="javascript:;" v-if="countdown == 60" @click="getcode()">{{
              sendcode
            }}</a>
            <a href="javascript:;" v-else>{{ sendcode }}</a>
          </div>
        </div>

        <a href="javascript:;" class="lighting" @click="reg">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
           注册</a
        ><br />
        <div class="reg">
          <router-link to="/login">登录</router-link>
          <span style="display: inline-block;width:10px;"></span>
          <router-link to="/index">返回主页</router-link>
          <!-- <a href="javascript:;" @click="back()">返回</a> -->

        </div>
      </form>
    </div>
  </div>
  <!-- 注册窗口 end -->
</template>

<script>
export default {
  data() {
    return {
      form: {
        mobile: "",
        password: "",
        code: ""
      },
      cf_password: "",
      sendcode: "获取验证码",

      countdown: 60
    };
  },

  beforeRouteLeave   (to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    console.log('to')
    console.log(to)
    console.log('from')
    console.log(from)
    console.log(this.countdown)
    // this.$urlfrom = from
    // console.log(this.$urlfrom)
    next();
  },
  methods: {
    back() {
      console.log(this.$urlfrom)
      // this.$router.go(-1);
    },
    getcode() {
    // 手机号正则
    if (!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
        this.$message({
        showClose: true,
        message: "手机号码有误，请重新填写 :<",
        type: "error"
        });
        return false;
    }
      if (this.countdown == 60) {


        // 获取手机验证码
        $.ajax({
          // url: "//'+ this.$API_URL +'/api/v1/getCode",
          url: "/api/v1/getCode",
          data: { mobile: this.form.mobile },
          type: "POST",
          timeout: 3000,
          success: ret => {


            if (ret.code == 200) {
              this.$message({
                showClose: true,
                message: ret.msg,
                type: "success"
              });
            } else {

              this.$message({
                showClose: true,
                message: ret.msg,
                type: "error"
              });
            }
          },
          error: ret => {


          }
        });
      }
      if (this.countdown == 0) {
        // obj.removeAttribute("disabled");
        this.sendcode = "获取验证码";
        this.countdown = 60;
        return;
      } else {
        // obj.setAttribute("disabled", true);
        this.sendcode = "重新发送(" + this.countdown + ")";
        this.countdown--;
      }
      // setTimeout(function(){settime(obj)},1000)
      setTimeout(() => {
        this.getcode();
      }, 1000);

    },


    reg() {

      // 手机号正则
      if (!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
        this.$message({
          showClose: true,
          message: "手机号码有误，请重新填写 :<",
          type: "error"
        });
        return false;
      }

      // 手机 密码 验证码 非空
      if (!(this.form.mobile && this.form.password && this.form.code)) {
        this.$message({
          showClose: true,
          message: "请将信息填写完整 :<",
          type: "error"
        });
        return false;
      }

      // 确认密码的判断
      if (this.form.password != this.cf_password) {
        this.$message({
          showClose: true,
          message: "两次设置的密码不一致 :<",
          type: "error"
        });
        return false;
      }

      if (this.form.password.length < 6) {
        this.$message({
          showClose: true,
          message: "密码的最小长度为6位 :<",
          type: "error"
        });
        return false;
      }
      // 注册
      $.ajax({
        // url: "//'+ this.$API_URL +'/api/v1/mobile_register",
        url: "/api/v1/mobile_register",
        data: this.form,
        type: "POST",
        timeout: 3000,
        success: ret => {


          if (ret.code == 201) {
            this.$message({
              showClose: true,
              message: ret.msg,
              type: "success"
            });

            localStorage.setItem("token", ret.data.id);
            this.$router.push("index");
          } else {
            this.$message({
              showClose: true,
              message: ret.msg,
              type: "error"
            });
          }
        },
        error: ret => {


        }
      });
    }
  }
};
</script>
<style scoped>
#body {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.getcode {
  text-align: right;
  position: absolute;
  right: 0;
  top: 10px;
}
.getcode a {
  color: #fff;
  text-decoration: none;
  display: block;
}
.getcode a:hover {
  color: #ff7400;
}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue